/* mc-home.js — početna, „Kako nastaje“: shows one of our real cards at a
   time. Starts on a random card (every visit shows a different one),
   moves every 4 s, dots jump to a card. Holds still with reduced motion
   and while the figure is hovered or has focus. Without JS the first
   card stays (markup has the others `hidden`).
   The card images are lazy; a hidden lazy image never loads, so a card
   would appear empty the moment it is shown. When the figure comes near
   the viewport all five are switched to eager, and only then does the
   rotation start. */
(function () {
  'use strict';
  var fig = document.querySelector('[data-mch-cards]');
  if (!fig) return;
  var cards = fig.querySelectorAll('[data-mch-card]');
  var dots = fig.querySelectorAll('[data-mch-dot]');
  var label = fig.querySelector('[data-mch-card-label]');
  var n = cards.length;
  if (n < 2) return;

  var cur = 0;
  function show(i) {
    cur = (i + n) % n;
    for (var k = 0; k < n; k++) {
      cards[k].hidden = k !== cur;
      if (dots[k]) dots[k].classList.toggle('is-on', k === cur);
    }
    if (label) label.textContent = cards[cur].getAttribute('data-label');
  }

  for (var d = 0; d < dots.length; d++) {
    dots[d].addEventListener('click', function () { show(+this.getAttribute('data-mch-dot')); });
  }

  show(Math.floor(Math.random() * n));

  var started = false;
  function start() {
    if (started) return;
    started = true;
    var imgs = fig.querySelectorAll('img');
    for (var j = 0; j < imgs.length; j++) imgs[j].loading = 'eager';
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var paused = false;
    fig.addEventListener('mouseenter', function () { paused = true; });
    fig.addEventListener('mouseleave', function () { paused = false; });
    fig.addEventListener('focusin', function () { paused = true; });
    fig.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var next = cards[(cur + 1) % n].querySelector('img');
      if (next && !next.complete) return; /* wait for it rather than show an empty frame */
      show(cur + 1);
    }, 4000);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); start(); }
    }, { rootMargin: '400px 0px' });
    io.observe(fig);
  } else {
    start();
  }
})();
